import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { SETTINGS_FEATURE_GROUP } from './group';

export const SETTINGS_FEATURES = {
  ACCESS: {
    guid: '3d12b9ef-6a96-4b5d-8d78-004ae25b0001',
    name: 'settings:access',
    description: 'Access the settings area for Altru integrations',
    action: 'read',
    product: 'app',
    parentGuid: SETTINGS_FEATURE_GROUP.guid,
  },
  ALTRU_CONNECTION_STATUS: {
    guid: '3d12b9ef-6a96-4b5d-8d78-004ae25b0011',
    name: 'settings:altru-connection-status',
    description: 'View the Altru integration connection status indicator',
    action: 'read',
    product: 'app',
    parentGuid: SETTINGS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { SETTINGS_FEATURE_GROUP } from './group';

export const SETTINGS_MODULE: FeatureModule = {
  product: 'app',
  groups: [SETTINGS_FEATURE_GROUP],
  features: featureList(SETTINGS_FEATURES),
};
